import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const TraceSection = () => {
  const cpoRef = useRef(null);
  const [cpoInView, setCpoInView] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (cpoRef.current) {
        const rect = cpoRef.current.getBoundingClientRect();
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {
          setCpoInView(true);
        } else {
          setCpoInView(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="CPO" className="py-4.5">
      <motion.div
        ref={cpoRef}
        initial={{ opacity: 0, y: 50 }}
        animate={cpoInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1 }}
        className="container"
      >
        <div id="CPO-CPO" className="row text-center text-white">
          <div className="col-12 mb-1">
            <h2>
              <b>Ingin tracing produk Anda?</b>
            </h2>
          </div>
          <div className="col-12 mb-1">
            <p>Silahkan mengklik dibawah ini</p>
          </div>
          <div className="col-md-12">
            <a href="/traceability" className="btn btn-outline-light">
              Trace Produk Anda
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default TraceSection;
